import product1 from "../../img/product-1.jpg"
import product2 from "../../img/product-2.jpg"
import product3 from "../../img/product-3.jpg"
import product4 from "../../img/product-4.jpg"
import product5 from "../../img/product-5.jpg"
import product6 from "../../img/product-6.jpg"
import product7 from "../../img/product-7.jpg"
import product8 from "../../img/product-8.jpg"
 const SData ={
    productsItem:[
            {
                productId: 1,
                name :"Colorful Stylish Shirt",
                dese:"Volup erat ipsum diam elitr rebum et dolor. Est nonumy elitr erat diam stet sit clita ea. Sanc invidunt ipsum et, labore clita lorem magna lorem ut. Erat lorem duo dolor no sea nonumy. Accus labore stet, est lorem sit diam sea et justo, amet at lorem et eirmod ipsum diam et rebum kasd rebum.",
                image:product1,
                price : 150,
                discprice:123,
                cat:"shirt"   
            },
            {
                productId: 2,
                name :"Colorful Stylish Shirt",
                dese:"Volup erat ipsum diam elitr rebum et dolor. Est nonumy elitr erat diam stet sit clita ea. Sanc invidunt ipsum et, labore clita lorem magna lorem ut. Erat lorem duo dolor no sea nonumy. Accus labore stet, est lorem sit diam sea et justo, amet at lorem et eirmod ipsum diam et rebum kasd rebum.",
                image:product2,
                price : 150,
                discprice:123,
                cat:"shirt"   
            },
            {
                productId: 3,
                name :"Colorful Stylish Shirt",
                dese:"Volup erat ipsum diam elitr rebum et dolor. Est nonumy elitr erat diam stet sit clita ea. Sanc invidunt ipsum et, labore clita lorem magna lorem ut. Erat lorem duo dolor no sea nonumy. Accus labore stet, est lorem sit diam sea et justo, amet at lorem et eirmod ipsum diam et rebum kasd rebum.",
                image:product3,
                price : 150,
                discprice:123,
                cat:"shirt"   
            },
            {
                productId: 4,
                name :"Colorful Stylish Shirt",
                dese:"Volup erat ipsum diam elitr rebum et dolor. Est nonumy elitr erat diam stet sit clita ea. Sanc invidunt ipsum et, labore clita lorem magna lorem ut. Erat lorem duo dolor no sea nonumy. Accus labore stet, est lorem sit diam sea et justo, amet at lorem et eirmod ipsum diam et rebum kasd rebum.",
                image:product4,
                price : 150,
                discprice:123,
                cat:"shirt"   
            },
            {
                productId: 5,
                name :"Colorful Stylish Shirt",
                dese:"Volup erat ipsum diam elitr rebum et dolor. Est nonumy elitr erat diam stet sit clita ea. Sanc invidunt ipsum et, labore clita lorem magna lorem ut. Erat lorem duo dolor no sea nonumy. Accus labore stet, est lorem sit diam sea et justo, amet at lorem et eirmod ipsum diam et rebum kasd rebum.",
                image:product5,
                price : 150,
                discprice:123,
                cat:"shirt"   
            },
            {
                productId: 6,
                name :"Colorful Stylish Shirt",
                dese:"Volup erat ipsum diam elitr rebum et dolor. Est nonumy elitr erat diam stet sit clita ea. Sanc invidunt ipsum et, labore clita lorem magna lorem ut. Erat lorem duo dolor no sea nonumy. Accus labore stet, est lorem sit diam sea et justo, amet at lorem et eirmod ipsum diam et rebum kasd rebum.",
                image:product6,
                price : 150,
                discprice:123,
                cat:"shirt"   
            },
            {
                productId: 7,
                name :"Colorful Stylish Shirt",
                dese:"Volup erat ipsum diam elitr rebum et dolor. Est nonumy elitr erat diam stet sit clita ea. Sanc invidunt ipsum et, labore clita lorem magna lorem ut. Erat lorem duo dolor no sea nonumy. Accus labore stet, est lorem sit diam sea et justo, amet at lorem et eirmod ipsum diam et rebum kasd rebum.",
                image:product7,
                price : 150,
                discprice:123,
                cat:"shirt"   
            },
            {
                productId: 8,
                name :"Colorful Stylish Shirt",
                dese:"Volup erat ipsum diam elitr rebum et dolor. Est nonumy elitr erat diam stet sit clita ea. Sanc invidunt ipsum et, labore clita lorem magna lorem ut. Erat lorem duo dolor no sea nonumy. Accus labore stet, est lorem sit diam sea et justo, amet at lorem et eirmod ipsum diam et rebum kasd rebum.",
                image:product8,
                price : 150,
                discprice:123,
                cat:"shirt"   
            },
            {
                productId: 9,
                name :"Colorful Stylish Shirt",
                dese:"Volup erat ipsum diam elitr rebum et dolor. Est nonumy elitr erat diam stet sit clita ea. Sanc invidunt ipsum et, labore clita lorem magna lorem ut. Erat lorem duo dolor no sea nonumy. Accus labore stet, est lorem sit diam sea et justo, amet at lorem et eirmod ipsum diam et rebum kasd rebum.",
                image:product1,
                price : 150,
                discprice:123,
                cat:"shirt"   
            },
            {
                productId: 10,
                name :"Colorful Stylish Shirt",
                dese:"Volup erat ipsum diam elitr rebum et dolor. Est nonumy elitr erat diam stet sit clita ea. Sanc invidunt ipsum et, labore clita lorem magna lorem ut. Erat lorem duo dolor no sea nonumy. Accus labore stet, est lorem sit diam sea et justo, amet at lorem et eirmod ipsum diam et rebum kasd rebum.",
                image:product4,
                price : 150,
                discprice:123,
                cat:"shirt"   
            },
            {
                productId: 11,
                name :"Colorful Stylish Shirt",
                dese:"Volup erat ipsum diam elitr rebum et dolor. Est nonumy elitr erat diam stet sit clita ea. Sanc invidunt ipsum et, labore clita lorem magna lorem ut. Erat lorem duo dolor no sea nonumy. Accus labore stet, est lorem sit diam sea et justo, amet at lorem et eirmod ipsum diam et rebum kasd rebum.",
                image:product5,
                price : 150,
                discprice:123,
                cat:"shirt"   
            },
            {
                productId: 12,
                name :"Colorful Stylish Shirt",
                dese:"Volup erat ipsum diam elitr rebum et dolor. Est nonumy elitr erat diam stet sit clita ea. Sanc invidunt ipsum et, labore clita lorem magna lorem ut. Erat lorem duo dolor no sea nonumy. Accus labore stet, est lorem sit diam sea et justo, amet at lorem et eirmod ipsum diam et rebum kasd rebum.",
                image:product6,
                price : 150,
                discprice:123,
                cat:"shirt"   
            },
        ]
}

export default SData